module.exports = __webpack_public_path__ + "img/avatar4.4544ce9d.png";